<template>
  <div>
    <label for="filters-id">{{filters.label}}</label>
    <select
      id="filters-id"
      v-on:change="updateValue"
      v-bind:eventName="eventName"
    >
      <option
        v-for="option in filters.options"
        v-bind:key="option.id"
        v-bind:value="option.value"
      >{{option.label}}</option>
    </select>
  </div>
</template>
<script>
export default {
  name: "drop-down",
  props: {
    filters: {
      type: Object,
      required: true
    },
    eventName: {
      type: String,
      required: true
    }
  },
  methods: {
    updateValue(item) {
      this.$eventBus.$emit(this.eventName, item.target.value);
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/components/entrade/community-search-results/dropdown.vue